import React from 'react';
import './AdminSideMenu.scss'
import dashboardIcon from '../../../assets/LVZ WEB ICONS - DASHBORAD.svg'
import membersIcon from '../../../assets/LVZ WEB ICONS - MEMBER.svg'
import eventsIcon from '../../../assets/LVZ WEB ICONS - EVENTS.svg'
import membersActivitiesIcon from '../../../assets/LVZ WEB ICONS - MEMBER ACTIVITIES.svg'
import languagesIcon from '../../../assets/LVZ WEB ICONS - LANGUAGES.svg'
import iTranslateIcon from '../../../assets/LVZ WEB ICONS - i TRANSLATE.svg'
import speechToTextIcon from '../../../assets/LVZ WEB ICONS - SPEECH TO TEXT.svg'
import speechToTranslationIcon from '../../../assets/LVZ WEB ICONS - SPEECH TO TRANSLATIONS.svg'
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getCurrentSubTab, getCurrentSubTabContainer, getCurrentTab } from '../../../redux/actions/adminSideMenuAction';
import { useHistory } from 'react-router';



const AdminSideMenu = () => {
    let history = useHistory()

    const sideMenu = useSelector(state => state.sideMenu)
    const dispatch = useDispatch()
    const {currentTab, currentSubTab, currentSubTabContainer} = sideMenu

    useEffect(() => {
        document.querySelectorAll('.tab').forEach(el=> el.classList.remove('active'))
        document.querySelectorAll('.sub-tab').forEach(el=> el.classList.remove('active'))
        
        if(currentSubTabContainer === 'itranslate') {
            document.querySelector('.itranslate-sub-tabs').classList.remove('hide') 
            document.querySelector('.itranslate-tab').classList.add('active')  
        } else {
            document.querySelector('.itranslate-sub-tabs').classList.add('hide')
        }

        if(currentSubTabContainer === 'mem-act') {
            document.querySelector('.mem-act-sub-tabs').classList.remove('hide') 
            document.querySelector('.mem-act-tab').classList.add('active')  
        } else {
            document.querySelector('.mem-act-sub-tabs').classList.add('hide')
        }


        if (currentSubTab === 's2text' ) {
            document.querySelector('.s2text-tab').classList.add('active')
            document.querySelector('.itranslate-tab').classList.add('active')
            history.push('/lvcconnectreact/admin/s2text')
        }

        if (currentSubTab === 's2trans' ) {
            document.querySelector('.s2trans-tab').classList.add('active')
            document.querySelector('.itranslate-tab').classList.add('active')
            history.push('/lvcconnectreact/admin/s2trans')
        }

        if (currentSubTab === 'notice' ) {
            document.querySelector('.notice-tab').classList.add('active')
            document.querySelector('.itranslate-tab').classList.add('active')
            history.push('/lvcconnectreact/admin/notice')
        }

        if (currentSubTab === 'actmon' ) {
            document.querySelector('.actmon-tab').classList.add('active')
            document.querySelector('.mem-act-tab').classList.add('active')
            window.location = 'https://admin.online.lvzconnect.org/v2/members-activities.php'
        }

        if (currentSubTab === 'seratt' ) {
            document.querySelector('.seratt-tab').classList.add('active')
            document.querySelector('.mem-act-tab').classList.add('active')
            history.push('/lvcconnectreact/admin/memact')
        }





        if (currentTab === 'languages') {
            document.querySelector('.lang-tab').classList.add('active')
            history.push('/lvcconnectreact/admin/languages')
        }

        if (currentTab === 'events') {
            document.querySelector('.events-tab').classList.add('active')
            history.push('/lvcconnectreact/admin/events')
        }

        if (currentTab === 'itranslate') {
            document.querySelector('.itranslate-tab').classList.add('active')
          
        }

        if (currentTab === 'dashboard') {
            document.querySelector('.dashboard-tab').classList.add('active')
            window.location = 'https://admin.online.lvzconnect.org/v2/index.php'
       
        }

        if (currentTab === 'members') {
            document.querySelector('.members-tab').classList.add('active')
            history.push('/lvcconnectreact/admin/members')
        }

        if (currentTab === 'mem-act') {
            document.querySelector('.mem-act-tab').classList.add('active')
        }
        
    }, [currentSubTab, currentSubTabContainer, currentTab, history])

    

    const handleITranslate = () => {

        if(currentSubTabContainer === 'itranslate') {
            dispatch(getCurrentSubTabContainer(''))
        } else {
            dispatch(getCurrentSubTabContainer('itranslate'))
        }
        

    }

    const handleMemAct = () => {

        if(currentSubTabContainer === 'mem-act') {
            dispatch(getCurrentSubTabContainer(''))
        } else {
            dispatch(getCurrentSubTabContainer('mem-act'))
        }
        

    }

    const handleITranslateSubTab = (subTab) => {
        dispatch(getCurrentSubTab(subTab))
        dispatch(getCurrentTab(''))
    }

    const handleLanguageTab = () => {
        dispatch(getCurrentTab('languages'))
        dispatch(getCurrentSubTabContainer(''))
        dispatch(getCurrentSubTab(''))
    }

    const handleEventTab = () => {
        dispatch(getCurrentTab('events'))
        dispatch(getCurrentSubTabContainer(''))
        dispatch(getCurrentSubTab(''))
    }

    const handleDashboardTab = () => {
        dispatch(getCurrentTab('dashboard'))
        dispatch(getCurrentSubTabContainer(''))
        dispatch(getCurrentSubTab(''))
    }

    const handleMembersTab = () => {
        dispatch(getCurrentTab('members'))
        dispatch(getCurrentSubTabContainer(''))
        dispatch(getCurrentSubTab(''))
    }

    const handleMemActTab = () => {
        dispatch(getCurrentTab('mem-act'))
        dispatch(getCurrentSubTabContainer(''))
        dispatch(getCurrentSubTab(''))
    }

    return (
        <aside className='admin-side-menu'>
            <h2>Main</h2>

            <ul className="side-tabs">

                <li className="tab dashboard-tab" onClick={handleDashboardTab}>
                    <img src={dashboardIcon} alt="" />
                    <p className='gg'>Dashboard</p>
                </li>

                <li className="tab members-tab" onClick={handleMembersTab}>
                    <img src={membersIcon} alt="" />
                    <p className='gg'>Members</p>
                </li>
                

                <li className="tab mem-act-tab" onClick={handleMemAct}>
                    <img src={membersActivitiesIcon} alt="" />
                    <p className='gg'>Members Activities</p>
                </li>
                <ul className="sub-tabs mem-act-sub-tabs hide">
                        <li className="sub-tab memactsub text  actmon-tab" onClick={() => handleITranslateSubTab('actmon')}>
                            <img src={membersActivitiesIcon} alt="" />
                            <p>Activity Monitor</p>
                        </li>

                        <li className="sub-tab memactsub trans seratt-tab" onClick={() => handleITranslateSubTab('seratt')}>
                            <img src={membersActivitiesIcon} alt="" />
                            <p>Service Attendance</p>
                        </li>
                </ul>

                <li className="tab events-tab" onClick={handleEventTab}>
                    <img src={eventsIcon} alt="" />
                    <p className='gg'>Events</p>
                </li>

                <li className="tab lang-tab" onClick={handleLanguageTab}>
                    <img src={languagesIcon} alt="" />
                    <p className='gg'>Languages</p>
                </li>

                <li className="tab translate  itranslate-tab" onClick={handleITranslate}>
                    <img src={iTranslateIcon} alt="" />
                    <p className='gg'>I-Translate</p>
                </li>

                <ul className="sub-tabs itranslate-sub-tabs hide">
                        <li className="sub-tab itransub text  s2text-tab" onClick={() => handleITranslateSubTab('s2text')}>
                            <img src={speechToTextIcon} alt="" />
                            <p>Speech To Text</p>
                        </li>

                        <li className="sub-tab itransub trans s2trans-tab" onClick={() => handleITranslateSubTab('s2trans')}>
                            <img src={speechToTranslationIcon} alt="" />
                            <p>Speech To Translation</p>
                        </li>

                        <li className="sub-tab itransub trans notice-tab" onClick={() => handleITranslateSubTab('notice')}>
                            <img src={speechToTranslationIcon} alt="" />
                            <p>Notice Post</p>
                        </li>
                </ul>
                
            </ul>
            
        </aside>
    )
}


export default AdminSideMenu